import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import SplitType from 'split-type';

let textAnimated = false;

gsap.registerPlugin(ScrollTrigger);

ScrollTrigger.create({
    trigger: document.querySelectorAll('.elementor-widget-webien_text_reveal'),
    start: "top 70%",
    //markers: true,
    onEnter: startTimeline,
});


function startTimeline(){

    if(textAnimated) return;

    textAnimated = true;

    let animateBlocks = document.querySelectorAll('.block');

    const tl = gsap.timeline({repeat: -1, repeatDelay: 0});
    let i = 0;

    animateBlocks.forEach(function(el){
        i++;

        let txtBlock = el.querySelector('.animated-text');
        let img = el.querySelector('.image');


        tl.to(txtBlock, {opacity: 1, duration: 0.5}, '-=0.5');
        tl.to(img, {opacity: 1, duration: 0.5}, '-=0.5');

        let animTxt = new SplitType(txtBlock, { types: 'words, chars' });
        let chars = animTxt.chars;

        tl.fromTo(
            chars,
            {
                y: 100,
                opacity: 0
            },
            {
                y: 0,
                opacity: 1,
                stagger: 0.05,
                duration: 1,
                ease: 'power4.out',
            }
        )

        tl.add(function(){}, '+=' + window.textAnimationSleep )  // Sleep for some seconds


        // Fade out all but last
      //  if(i < animateBlocks.length){
            tl.to(txtBlock,  {opacity: 0, duration: 0.5}, '-=0.5');
            tl.to(img,  {opacity: 0, duration: 0.5}, '-=0.5');
            //tl.to(el, {opacity: 0, duration: 0.5});
      //  }



    });

    // Run the timeline once and go to end.. weirdness of image opacities
    //tl.seek("-=0");


}







